var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: {
        form: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
        width: "800px",
      },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _vm.isEdit
                    ? _c("BjLogButton", {
                        attrs: {
                          id: _vm.form.id,
                          permission: "BusinessChannelPhysicalList_Log",
                          title: _vm.form.name,
                          api: "channelApi",
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v("基本信息 ")]
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "门店名称", prop: "name" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c("BjFormItemCode", {
            attrs: { readonly: _vm.isEdit, label: "门店编码", prop: "code" },
            model: {
              value: _vm.form.code,
              callback: function ($$v) {
                _vm.$set(_vm.form, "code", $$v)
              },
              expression: "form.code",
            },
          }),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "门店类型", prop: "typeCode" } },
            [
              _c("BjSelectLov", {
                attrs: { "lov-code": "SCHL.SHOP_TYPE" },
                model: {
                  value: _vm.form.typeCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "typeCode", $$v)
                  },
                  expression: "form.typeCode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "负责人", prop: "manager" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.manager,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "manager", $$v)
                  },
                  expression: "form.manager",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "所属公司", prop: "salesOrganizingId" } },
            [
              _c("BjCompanyTreeSelect", {
                attrs: { clearable: "" },
                model: {
                  value: _vm.form.salesOrganizingId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "salesOrganizingId", $$v)
                  },
                  expression: "form.salesOrganizingId",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "发票种类", prop: "invoiceTypeCode" } },
            [
              _c("BjSelectLov", {
                attrs: { "lov-code": "SCHL.INVOICE_TYPE" },
                model: {
                  value: _vm.form.invoiceTypeCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "invoiceTypeCode", $$v)
                  },
                  expression: "form.invoiceTypeCode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "门店地址", prop: "fullAddress" } },
            [
              _c(
                "el-col",
                { attrs: { span: 11 } },
                [
                  _c("BjRegionCascader", {
                    staticClass: "full-width",
                    attrs: { "is-array": "", clearable: "" },
                    model: {
                      value: _vm.regionList,
                      callback: function ($$v) {
                        _vm.regionList = $$v
                      },
                      expression: "regionList",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 13 } },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: "详细地址",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "address", $$v)
                      },
                      expression: "form.address",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "描述", prop: "description" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.isEdit ? "编辑" : "创建") + "渠道仓"),
      ]),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "渠道仓名称", prop: "channelWarehouseName" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.channelWarehouseName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "channelWarehouseName", $$v)
                  },
                  expression: "form.channelWarehouseName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: { prop: "selfPickupFlag", "label-width": "225px" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [
                      _vm._v(" 是否为O2O订单自提门店 "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            placement: "top-start",
                            content:
                              "当设自提门店时，则O2O订单可以选择此门店作为自提点",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("el-switch", {
                model: {
                  value: _vm.form.selfPickupFlag,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "selfPickupFlag", $$v)
                  },
                  expression: "form.selfPickupFlag",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }